import { render, staticRenderFns } from "./policy-added.vue?vue&type=template&id=a2416dd8&scoped=true&"
import script from "./policy-added.vue?vue&type=script&lang=js&"
export * from "./policy-added.vue?vue&type=script&lang=js&"
import style0 from "./policy-added.vue?vue&type=style&index=0&id=a2416dd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2416dd8",
  null
  
)

export default component.exports